import styled, {css} from "styled-components";
import {FlexContainer} from "BaseComponents/Flex";
import {StyledBackgroundImage} from "Framework/lazy/StyledBgImage";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";

export const ImageContainer = styled.div`
    margin-bottom: 30px;
`;
export const StandardImageWrapper = styled(FlexContainer).attrs(({}) => ({}))`
    height: ${({height}) => (height ? height : "")};
    flex-direction: column;

    ${StyledBackgroundImage} {
        border-top-left-radius: ${({theme}) => theme.border.radius};
        border-top-right-radius: ${({theme}) => theme.border.radius};
    }
`;
export const Image = styled.div`
    background-image: ${({bgImage}) => (bgImage ? `url(${bgImage})` : "")};
    background-position: center;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: ${({useAspectRatio}) => useAspectRatio ? 'contain' : 'cover'};
    ${({useAspectRatio}) =>
            useAspectRatio &&
            css`
                aspect-ratio: 16/9;
            `}
`;
export const Img = styled.img`
    max-width: ${({maxWidth}) => maxWidth};
    ${media.lessThan(breakpoints.mobile)`
	display: none;
`}
`;
